import { isDemoMode } from "@/lib/runtimeMode";
import { getSupabaseClient } from "../providers/supabase/supabase";
import {
  defaultProfiles,
  installRoleProfiles,
  type RoleProfile,
} from "./roleProfiles";
const key = "rovero-role-profiles-v1";
let loadedAt = 0;
let pending: Promise<RoleProfile[]> | undefined;
export function loadRoleProfiles(force = false): Promise<RoleProfile[]> {
  if (force || (loadedAt > 0 && Date.now() - loadedAt > 60000)) {
    pending = undefined;
    loadedAt = 0;
  }
  return (pending ??= (async () => {
    let profiles: RoleProfile[];
    if (isDemoMode())
      profiles =
        JSON.parse(localStorage.getItem(key) ?? "null") ?? defaultProfiles();
    else {
      const { data, error } = await getSupabaseClient()
        .from("crm_role_profiles")
        .select("profile");
      if (error) throw error;
      profiles = data.length ? data.map((r) => r.profile) : defaultProfiles();
    }
    loadedAt = Date.now();
    installRoleProfiles(profiles);
    return profiles;
  })().catch((e) => {
    pending = undefined;
    throw e;
  }));
}
export async function saveRoleProfile(profile: RoleProfile) {
  if (isDemoMode()) {
    const all = await loadRoleProfiles();
    const next = [...all.filter((p) => p.id !== profile.id), profile];
    localStorage.setItem(key, JSON.stringify(next));
    installRoleProfiles(next);
    pending = Promise.resolve(next);
  } else {
    const { error } = await getSupabaseClient().rpc("save_crm_role_profile", {
      p_profile: profile,
    });
    if (error) throw error;
    await loadRoleProfiles(true);
  }
}
